import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Card from "../../../components/Card";
import { toast } from "react-toastify";
import {
  API_CALL_CENTRE_PROFILE,
  API_COUNTRY_CODES_LIST,
  API_TIMEZONES_LIST,
  API_PARENT_CALL_CENTER_LICENCE,
  API_COUNTRY_CODE_DIRECTIONS_MASTER_LIST,
  API_USER_COUNTRY_CODE_DIRECTIONS_BY_CALL_CENTRE,
} from "../../../service/url";
import CountryCodeDirectionPicker from "../../../components/partials/dashboard/country-code-direction/CountryCodeDirectionPicker";
import LicenceAllocationPanel from "../../../components/partials/dashboard/company/LicenceAllocationPanel";
import { postApiCall, getApiCall, fetchAndSetFlashMessage } from "../../../service/httpCall";
import { useNavigate, useParams } from "react-router-dom";
import {
  ROUTES,
  USER_ROLES,
  MODULE_ACL,
  FLASH_MESSAGE_ACTION_OBJECT,
} from "../../../utilities/constant";
import { useAuth, errorCheck } from "../auth/auth-utils";
import { Storage } from "../../../utilities/setting";
import {
  FiUser,
  FiGlobe,
  FiClock,
  FiAlignLeft,
  FiFlag,
  FiUsers,
  FiActivity,
  FiShare2,
  FiPhone,
  FiSmartphone,
} from "react-icons/fi";
import { FaHeadset } from "react-icons/fa";
import "../../../assets/custom/css/custom.css";

function IconField({ icon: Icon, children, hasTrailing, trailingIcon: TrailingIcon, textarea }) {
  return (
    <div
      className={`ccf-input-with-icon${textarea ? " ccf-input-with-icon--textarea" : ""}${
        hasTrailing ? " ccf-input-with-icon--trailing" : ""
      }${TrailingIcon ? " ccf-input-with-icon--icon-right" : ""}`}
    >
      {!TrailingIcon && Icon && (
        <span className="ccf-input-with-icon__icon">
          <Icon size={18} />
        </span>
      )}
      {children}
      {TrailingIcon && (
        <span className="ccf-input-with-icon__icon ccf-input-with-icon__icon--right">
          <TrailingIcon size={18} />
        </span>
      )}
    </div>
  );
}

const CallCentreUpdate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();

  const [name, setName] = useState("");
  const [domain, setDomain] = useState("");
  const [description, setDescription] = useState("");
  const [buttonDisable, setButtonDisable] = useState(false);
  const [countryCodeList, setCountryCodeList] = useState([]);
  const [countryCode, setCountryCode] = useState("");
  const [timezonesList, setTimezonesList] = useState([]);
  const [timezone, setTimezone] = useState("");
  const [filteredTimezones, setFilteredTimezones] = useState([]);
  const [agent, setAgent] = useState(0);
  const [liveAgent, setLiveAgent] = useState(0);
  const [channel, setChannel] = useState(0);
  const [cps, setCps] = useState(0);
  const [mobile, setMobile] = useState(0);
  const [errors, setErrors] = useState({});
  const [loginUserRole, setLoginUserRole] = useState(null);
  const [parentLicence, setParentLicence] = useState(null);
  const [initialLicence, setInitialLicence] = useState({});
  const [usedLicence, setUsedLicence] = useState({});
  const [nameError, setNameError] = useState("");
  const [domainError, setDomainError] = useState("");
  const [notes, setNotes] = useState([]);
  const [countryCodeDirections, setCountryCodeDirections] = useState([]);
  const [selectedCountryCodeDirections, setSelectedCountryCodeDirections] = useState([]);
  const [profileLoaded, setProfileLoaded] = useState(false);

  function getProfileApiUrl() {
    return API_CALL_CENTRE_PROFILE.replace(":id", id);
  }

  useEffect(() => {
    checkAuth();
    try {
      const user = JSON.parse(Storage.getItem("user"));
      if (user?.role) {
        setLoginUserRole(user.role);
      }
    } catch (err) {
      console.log(err);
    }

    fetchAndSetFlashMessage(
      (msg) =>
        msg.module_name === MODULE_ACL.CALL_CENTRE &&
        msg.action === FLASH_MESSAGE_ACTION_OBJECT.EDIT &&
        msg.type === "Note",
      setNotes
    );

    getApiCall(API_PARENT_CALL_CENTER_LICENCE)
      .then((resp) => setParentLicence(resp?.parentLicence))
      .catch((error) => {
        toast.warning(typeof error === "string" ? error : JSON.stringify(error));
      });

    getApiCall(API_COUNTRY_CODES_LIST, {})
      .then((resp) => setCountryCodeList(resp))
      .catch(onError);

    getApiCall(API_TIMEZONES_LIST, {})
      .then((resp) => setTimezonesList(resp))
      .catch(onError);

    getApiCall(API_COUNTRY_CODE_DIRECTIONS_MASTER_LIST, {})
      .then((data) => setCountryCodeDirections(Array.isArray(data) ? data : []))
      .catch(() => setCountryCodeDirections([]));

    getApiCall(API_USER_COUNTRY_CODE_DIRECTIONS_BY_CALL_CENTRE(id), {})
      .then((data) => {
        const ids = Array.isArray(data)
          ? data.map((item) => item.country_code_direction_id).filter(Boolean)
          : [];
        setSelectedCountryCodeDirections(ids);
      })
      .catch(() => {});

    getApiCall(getProfileApiUrl(), {})
      .then((resp) => {
        setName(resp.name || "");
        setDomain(resp.domain || "");
        setDescription(resp.description || "");
        setCountryCode(resp.country_code_id || "");
        setTimezone(resp.timezone_id || "");

        const licence = resp?.subUserLicenceId || {};
        const available = licence?.available_licence || {};
        const used = licence?.used_licence || {};

        setUsedLicence(used);

        const currentValues = {
          role_ccagent: available.role_ccagent || 0,
          live_agent: available.live_agent || 0,
          channel: available.channel || 0,
          cps: available.cps || 0,
          mobile: available.mobile || 0,
        };

        setAgent(currentValues.role_ccagent);
        setLiveAgent(currentValues.live_agent);
        setChannel(currentValues.channel);
        setCps(currentValues.cps);
        setMobile(currentValues.mobile);
        setInitialLicence(currentValues);
        setProfileLoaded(true);
      })
      .catch(onError);
  }, [id]);

  useEffect(() => {
    if (!countryCode || !timezonesList.length || !countryCodeList.length) return;

    const selectedCountry = countryCodeList.find((c) => c.id === countryCode);
    if (selectedCountry) {
      const filtered = timezonesList.filter((tz) =>
        tz.value.toLowerCase().includes(selectedCountry.name.toLowerCase())
      );
      setFilteredTimezones(filtered);
    } else {
      setFilteredTimezones([]);
    }
  }, [countryCode, timezonesList, countryCodeList]);

  const licenceKeyMap = {
    agent: "role_ccagent",
    live_agent: "live_agent",
    channel: "channel",
    cps: "cps",
    mobile: "mobile",
  };

  const getLicenceMax = (key) => {
    const licenceKey = licenceKeyMap[key];
    const parentAvailable = Number(parentLicence?.available_licence?.[licenceKey] || 0);
    const initialValue = Number(initialLicence?.[licenceKey] || 0);
    return parentAvailable + initialValue;
  };

  const validateInput = (value, key) => {
    if (value === "" || value == null) {
      return 0;
    }
    const digitsOnly = String(value).replace(/\D/g, "");
    if (digitsOnly === "") {
      return 0;
    }
    const num = parseInt(digitsOnly, 10);
    let newErrors = { ...errors };

    if (Number.isNaN(num)) return 0;
    if (num < 0) {
      newErrors[key] = "Value cannot be negative";
      setErrors(newErrors);
      return 0;
    }

    const maxAllowed = getLicenceMax(key);

    if (num > maxAllowed) {
      newErrors[key] = `Value cannot exceed ${maxAllowed}`;
      setErrors(newErrors);
      return num;
    }

    newErrors[key] = "";

    const nextAgent = key === "agent" ? num : agent;
    const nextLiveAgent = key === "live_agent" ? num : liveAgent;

    if (nextAgent < nextLiveAgent) {
      newErrors.agent = "Total Agent cannot be less than Live Agent";
      newErrors.live_agent = "Live Agent cannot be more than Total Agent";
    } else if (!newErrors[key]) {
      newErrors.agent = "";
      newErrors.live_agent = "";
    }

    setErrors(newErrors);
    return num;
  };

  const stepLicence = (key, current, setter, delta) => {
    const next = Math.max(0, (parseInt(String(current), 10) || 0) + delta);
    setter(validateInput(String(next), key));
  };

  const canIncrementLicence = (key, current) => {
    const max = getLicenceMax(key);
    return (parseInt(String(current), 10) || 0) < max;
  };

  const handleCountryChange = (e) => {
    const selectedCountryId = e.target.value;
    setCountryCode(selectedCountryId);
    setTimezone("");

    const selectedCountry = countryCodeList.find((c) => c.id === selectedCountryId);
    if (selectedCountry) {
      const filtered = timezonesList.filter((tz) =>
        tz.value.toLowerCase().includes(selectedCountry.name.toLowerCase())
      );
      setFilteredTimezones(filtered);
    } else {
      setFilteredTimezones([]);
    }
  };

  function onError(err) {
    if (typeof err !== "object" && err?.includes?.("TokenExpiredError")) {
      errorCheck(err, navigate);
    } else {
      console.log(err);
    }
  }

  const validateName = (value) => {
    const trimmedValue = value.trim();
    if (!trimmedValue) {
      setNameError("Name is required");
      return false;
    }
    if (trimmedValue.length < 3) {
      setNameError("Name must be at least 3 characters long");
      return false;
    }
    if (trimmedValue.length > 500) {
      setNameError("Name must not exceed 500 characters");
      return false;
    }
    const nameRegex = /^[a-zA-Z0-9_]+$/;
    if (!nameRegex.test(trimmedValue)) {
      setNameError(
        "Name can only contain letters, numbers, and underscores (_). No special characters allowed."
      );
      return false;
    }
    setNameError("");
    return true;
  };

  const validateDomain = (value) => {
    const trimmedValue = value.trim();
    if (!trimmedValue) {
      setDomainError("Domain is required");
      return false;
    }
    if (trimmedValue.length > 500) {
      setDomainError("Domain must not exceed 500 characters");
      return false;
    }
    const domainRegex = /^(https?:\/\/)?([\w\.\-@]+)([\/\w \.\-@]*)*\/?$/i;
    if (!domainRegex.test(trimmedValue)) {
      setDomainError(
        "Please enter a valid domain or URL (e.g., example.com or https://example.com)"
      );
      return false;
    }
    setDomainError("");
    return true;
  };

  function validateForm() {
    let valid = true;
    let errorMessage = "";

    const nameValid = validateName(name);
    const domainValid = validateDomain(domain);

    if (!nameValid) {
      valid = false;
      errorMessage = nameError || "Name validation failed";
    }
    if (!domainValid) {
      valid = false;
      errorMessage = errorMessage
        ? `${errorMessage}; ${domainError || "Domain validation failed"}`
        : domainError || "Domain validation failed";
    }
    if (!description.trim()) {
      valid = false;
      errorMessage = errorMessage ? `${errorMessage}; Description required` : "Description required";
    }
    if (!countryCode) {
      valid = false;
      errorMessage = errorMessage
        ? `${errorMessage}; Country Code required`
        : "Country Code required";
    }
    if (!timezone) {
      valid = false;
      errorMessage = errorMessage
        ? `${errorMessage}; Timezone required`
        : "Timezone required";
    }

    if (!valid && errorMessage) {
      toast.warning(errorMessage);
    }

    return valid;
  }

  async function submitForm() {
    setButtonDisable(true);

    if (!validateForm()) {
      setButtonDisable(false);
      return;
    }

    if (Object.values(errors).some((error) => error !== "")) {
      toast.warning("Please fix all validation errors before submitting");
      setButtonDisable(false);
      return;
    }

    const params = {
      name,
      domain,
      description,
      countryCode,
      timezone,
      licence: {
        role_ccagent: agent,
        live_agent: liveAgent,
        channel,
        cps,
        mobile,
        reseller: 0,
        company: 0,
      },
      country_code_directions: Array.isArray(selectedCountryCodeDirections)
        ? selectedCountryCodeDirections.map(Number)
        : [],
    };

    postApiCall(getProfileApiUrl(), params)
      .then(onCallCentreUpdateSuccess)
      .catch(onCallCentreUpdateError);
  }

  function onCallCentreUpdateSuccess() {
    toast.success("Call centre updated successfully");
    setTimeout(() => {
      navigate(`/${ROUTES.CALL_CENTRES.LIST}`);
    }, 1500);
  }

  function onCallCentreUpdateError(err) {
    if (typeof err !== "object" && err?.includes?.("TokenExpiredError")) {
      errorCheck(err, navigate);
    } else {
      setButtonDisable(false);
      toast.warning(typeof err === "string" ? err : JSON.stringify(err));
    }
  }

  const licenceNote =
    notes.find((n) => Number(n.priority) === 1)?.message ??
    "Adjust licence counts within your company pool. Increases use available company licences; decreases return unused capacity.";

  const licenceFooterNote =
    loginUserRole !== USER_ROLES.SUPERADMIN
      ? notes.find((n) => Number(n.priority) === 2)?.message ??
        "Available company licences are shown below for reference."
      : "";

  const hasLicenceErrors = Object.values(errors).some((e) => e !== "");
  const showCallCenterUsedCol =
    loginUserRole !== USER_ROLES.CALL_CENTRE_ADMIN &&
    loginUserRole !== USER_ROLES.COMPANY_ADMIN;

  return (
    <div>
      <Row>
        <Col xl="12" lg="12">
          <Card>
            <Card.Header className="d-none" />
            <Card.Body className="call-centre-create-form-card">
              <div className="new-user-info company-create-form call-centre-create-form">
                <div className="user-create-form__hero">
                  <div className="user-create-form__hero-left">
                    <span className="user-create-form__hero-icon" aria-hidden="true">
                      <FaHeadset size={22} />
                    </span>
                    <div>
                      <h5 className="user-create-form__hero-title">Update Call Centre Information</h5>
                      <p className="user-create-form__hero-subtitle">
                        Edit call centre details and adjust licence allocation from your company pool.
                      </p>
                    </div>
                  </div>
                  <div className="user-create-form__required-note">
                    Fields marked with <span className="text-danger">*</span> are required
                  </div>
                </div>

                {!profileLoaded ? (
                  <p className="text-muted mb-0">Loading call centre details…</p>
                ) : (
                  <form>
                    <div className="row g-3 call-centre-create-form__row">
                      <Form.Group className="col-12 col-lg-6 form-group mb-0">
                        <Form.Label>
                          Name <span className="text-danger">*</span>
                        </Form.Label>
                        <IconField icon={FiUser}>
                          <Form.Control
                            type="text"
                            id="name"
                            maxLength={500}
                            value={name}
                            className={`ccf-input-with-icon__control${
                              nameError ? " is-invalid" : ""
                            }`}
                            placeholder="Call centre name"
                            onChange={(e) => {
                              setName(e.target.value);
                              validateName(e.target.value);
                            }}
                            onBlur={(e) => validateName(e.target.value)}
                            required
                          />
                        </IconField>
                        {nameError && (
                          <div className="invalid-feedback d-block">{nameError}</div>
                        )}
                      </Form.Group>

                      <Form.Group className="col-12 col-lg-6 form-group mb-0">
                        <Form.Label>
                          Domain <span className="text-danger">*</span>
                        </Form.Label>
                        <IconField icon={FiGlobe}>
                          <Form.Control
                            type="text"
                            id="domain"
                            maxLength={500}
                            value={domain}
                            className={`ccf-input-with-icon__control${
                              domainError ? " is-invalid" : ""
                            }`}
                            placeholder="https://example.com"
                            onChange={(e) => {
                              setDomain(e.target.value);
                              validateDomain(e.target.value);
                            }}
                            onBlur={(e) => validateDomain(e.target.value)}
                            required
                          />
                        </IconField>
                        {domainError && (
                          <div className="invalid-feedback d-block">{domainError}</div>
                        )}
                      </Form.Group>

                      <Form.Group className="col-12 col-lg-6 form-group mb-0">
                        <Form.Label>
                          Country Code <span className="text-danger">*</span>
                        </Form.Label>
                        <IconField icon={FiFlag}>
                          <Form.Select
                            id="countryCode"
                            required
                            value={countryCode}
                            className="ccf-input-with-icon__control ccf-input-with-icon__select"
                            onChange={handleCountryChange}
                          >
                            <option value="">Select country</option>
                            {countryCodeList.map((val) => (
                              <option key={val.id} value={val.id}>
                                {val.name}
                              </option>
                            ))}
                          </Form.Select>
                        </IconField>
                      </Form.Group>

                      <Form.Group className="col-12 col-lg-6 form-group mb-0">
                        <Form.Label>
                          Timezone <span className="text-danger">*</span>
                        </Form.Label>
                        <IconField trailingIcon={FiClock}>
                          <Form.Select
                            id="timezone"
                            required
                            value={timezone}
                            disabled={!countryCode}
                            className="ccf-input-with-icon__control ccf-input-with-icon__select ccf-input-with-icon__control--date"
                            onChange={(e) => setTimezone(e.target.value)}
                          >
                            <option value="">Select timezone</option>
                            {filteredTimezones.map((val) => (
                              <option key={val.id} value={val.id}>
                                {val.value}
                              </option>
                            ))}
                          </Form.Select>
                        </IconField>
                      </Form.Group>

                      <Form.Group className="col-12 form-group mb-0">
                        <Form.Label>
                          Description <span className="text-danger">*</span>
                        </Form.Label>
                        <IconField icon={FiAlignLeft} textarea>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            id="description"
                            maxLength={500}
                            value={description}
                            className="ccf-input-with-icon__control ccf-input-with-icon__control--textarea"
                            placeholder="Describe this call centre"
                            onChange={(e) => setDescription(e.target.value)}
                            required
                          />
                        </IconField>
                      </Form.Group>

                      <CountryCodeDirectionPicker
                        items={countryCodeDirections}
                        selectedIds={selectedCountryCodeDirections}
                        onChange={setSelectedCountryCodeDirections}
                        label="Country Codes"
                        placeholder="Select country codes"
                        groupClassName="col-12 col-lg-6 form-group mb-0"
                        iconWrap
                      />
                    </div>

                    <LicenceAllocationPanel
                      showNote
                      subtitle="Adjust licences allocated to this call centre"
                      noteMessage={licenceNote}
                      footerNote={licenceFooterNote}
                      columns={[
                        {
                          key: "agent",
                          icon: FiUsers,
                          iconModifier: "agent",
                          title: "Total Agent",
                          description: "Total number of agents",
                          value: parseInt(String(agent), 10) || 0,
                          onChange: (val) => setAgent(validateInput(String(val), "agent")),
                          onDecrement: () => stepLicence("agent", agent, setAgent, -1),
                          onIncrement: () => stepLicence("agent", agent, setAgent, 1),
                          disabledMinus: (parseInt(String(agent), 10) || 0) <= 0,
                          disabledPlus: !canIncrementLicence(
                            "agent",
                            parseInt(String(agent), 10) || 0
                          ),
                          error: errors.agent,
                        },
                        {
                          key: "live_agent",
                          icon: FiActivity,
                          iconModifier: "live",
                          title: "Live Agent",
                          description: "Agents for live calls",
                          value: parseInt(String(liveAgent), 10) || 0,
                          onChange: (val) =>
                            setLiveAgent(validateInput(String(val), "live_agent")),
                          onDecrement: () =>
                            stepLicence("live_agent", liveAgent, setLiveAgent, -1),
                          onIncrement: () =>
                            stepLicence("live_agent", liveAgent, setLiveAgent, 1),
                          disabledMinus: (parseInt(String(liveAgent), 10) || 0) <= 0,
                          disabledPlus: !canIncrementLicence(
                            "live_agent",
                            parseInt(String(liveAgent), 10) || 0
                          ),
                          error: errors.live_agent,
                        },
                        {
                          key: "channel",
                          icon: FiShare2,
                          iconModifier: "channel",
                          title: "Channels",
                          description: "Communication channels",
                          value: parseInt(String(channel), 10) || 0,
                          onChange: (val) => setChannel(validateInput(String(val), "channel")),
                          onDecrement: () => stepLicence("channel", channel, setChannel, -1),
                          onIncrement: () => stepLicence("channel", channel, setChannel, 1),
                          disabledMinus: (parseInt(String(channel), 10) || 0) <= 0,
                          disabledPlus: !canIncrementLicence(
                            "channel",
                            parseInt(String(channel), 10) || 0
                          ),
                          error: errors.channel,
                        },
                        {
                          key: "cps",
                          icon: FiPhone,
                          iconModifier: "channel",
                          title: "CPS",
                          description: "Calls per second",
                          value: parseInt(String(cps), 10) || 0,
                          onChange: (val) => setCps(validateInput(String(val), "cps")),
                          onDecrement: () => stepLicence("cps", cps, setCps, -1),
                          onIncrement: () => stepLicence("cps", cps, setCps, 1),
                          disabledMinus: (parseInt(String(cps), 10) || 0) <= 0,
                          disabledPlus: !canIncrementLicence(
                            "cps",
                            parseInt(String(cps), 10) || 0
                          ),
                          error: errors.cps,
                        },
                        {
                          key: "mobile",
                          icon: FiSmartphone,
                          iconModifier: "mobile",
                          title: "Mobile License",
                          description: "Mobile dialer licences",
                          value: parseInt(String(mobile), 10) || 0,
                          onChange: (val) => setMobile(validateInput(String(val), "mobile")),
                          onDecrement: () => stepLicence("mobile", mobile, setMobile, -1),
                          onIncrement: () => stepLicence("mobile", mobile, setMobile, 1),
                          disabledMinus: (parseInt(String(mobile), 10) || 0) <= 0,
                          disabledPlus: !canIncrementLicence(
                            "mobile",
                            parseInt(String(mobile), 10) || 0
                          ),
                          error: errors.mobile,
                        },
                      ]}
                      availableSummary={
                        loginUserRole !== USER_ROLES.SUPERADMIN ? (
                          <div className="licence-available-summary">
                            <h6 className="licence-available-summary__title">
                              Available Licence (Allocated Company)
                            </h6>
                            <div className="licence-available-summary__row">
                              <span>
                                Agent: {parentLicence?.available_licence?.role_ccagent ?? 0}
                              </span>
                              <span>
                                Live Agent: {parentLicence?.available_licence?.live_agent ?? 0}
                              </span>
                              <span>
                                Channels: {parentLicence?.available_licence?.channel ?? 0}
                              </span>
                              <span>
                                CPS: {parentLicence?.available_licence?.cps ?? 0}
                              </span>
                              <span>
                                Mobile: {parentLicence?.available_licence?.mobile ?? 0}
                              </span>
                            </div>
                            <h6 className="licence-available-summary__title mt-3">
                              Used Licence (This Call Centre)
                            </h6>
                            <div className="licence-available-summary__row">
                              {showCallCenterUsedCol && (
                                <span>
                                  Call Centers: {usedLicence?.role_ccadmin ?? 0}
                                </span>
                              )}
                              <span>Agent: {usedLicence?.role_ccagent ?? 0}</span>
                              <span>Live Agent: {usedLicence?.live_agent ?? 0}</span>
                              <span>Channels: {usedLicence?.channel ?? 0}</span>
                              <span>CPS: {usedLicence?.cps ?? 0}</span>
                              <span>Mobile: {usedLicence?.mobile ?? 0}</span>
                            </div>
                          </div>
                        ) : null
                      }
                    />

                    <div className="form-actions call-centre-create-form__actions">
                      <Button
                        onClick={submitForm}
                        type="button"
                        variant="btn btn-primary"
                        disabled={
                          buttonDisable || hasLicenceErrors || !!nameError || !!domainError
                        }
                      >
                        <FaHeadset className="me-2" />
                        Update Call Centre
                        {buttonDisable ? (
                          <span
                            className="spinner-border spinner-border-sm ms-2"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : null}
                      </Button>
                    </div>
                  </form>
                )}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default CallCentreUpdate;
